import {Pipe, PipeTransform} from '@angular/core';
import {AuthService} from "../_services/auth.service";

@Pipe({
    name: 'nameDisplay',
    pure: true
})
export class NameDisplayPipe implements PipeTransform {

    constructor(private authService: AuthService) {
    }

    transform(user: any, context?: 'reference_number' | 'email' | 'username' | 'role', defaultValue?: string, location?: 'timeline' | 'profile' | 'nav'): string {
        return this.authService.getDisplayName(user, context, defaultValue, location)
    }
}
